export default {
    props: {
        panesBackground: {
            type: String,
            kComposite: 'panes.background'
        }, 
        panesBorderColor: {
            type: String,
            kComposite: 'panes.border.color'
        }, 
        panesBorderDashType: {
            type: String,
            kComposite: 'panes.border.dashType'
        }, 
        panesBorderWidth: {
            type: Number,
            kComposite: 'panes.border.width'
        }, 
        panesClip: {
            type: Boolean,
            kComposite: 'panes.clip'
        }, 
        panesHeight: {
            type: Number,
            kComposite: 'panes.height'
        }, 
        panesMargin: {
            type: Number,
            kComposite: 'panes.margin'
        }, 
        panesMarginBottom: {
            type: Number,
            kComposite: 'panes.margin.bottom'
        }, 
        panesMarginLeft: {
            type: Number,
            kComposite: 'panes.margin.left'
        }, 
        panesMarginRight: {
            type: Number,
            kComposite: 'panes.margin.right'
        }, 
        panesMarginTop: {
            type: Number,
            kComposite: 'panes.margin.top'
        }, 
        panesName: {
            type: String,
            kComposite: 'panes.name'
        }, 
        panesPadding: {
            type: Number,
            kComposite: 'panes.padding'
        }, 
        panesPaddingBottom: {
            type: Number,
            kComposite: 'panes.padding.bottom'
        }, 
        panesPaddingLeft: {
            type: Number,
            kComposite: 'panes.padding.left'
        }, 
        panesPaddingRight: {
            type: Number,
            kComposite: 'panes.padding.right'
        }, 
        panesPaddingTop: {
            type: Number,
            kComposite: 'panes.padding.top'
        }, 
        panesTitle: {
            type: String,
            kComposite: 'panes.title'
        }, 
        panesTitleBackground: {
            type: String,
            kComposite: 'panes.title.background'
        }, 
        panesTitleBorderColor: {
            type: String,
            kComposite: 'panes.title.border.color'
        }, 
        panesTitleBorderDashType: {
            type: String,
            kComposite: 'panes.title.border.dashType'
        }, 
        panesTitleBorderWidth: {
            type: Number,
            kComposite: 'panes.title.border.width'
        }, 
        panesTitleColor: {
            type: String,
            kComposite: 'panes.title.color'
        }, 
        panesTitleFont: {
            type: String,
            kComposite: 'panes.title.font'
        }, 
        panesTitleMargin: {
            type: Number,
            kComposite: 'panes.title.margin'
        }, 
        panesTitleMarginBottom: {
            type: Number,
            kComposite: 'panes.title.margin.bottom'
        }, 
        panesTitleMarginLeft: {
            type: Number,
            kComposite: 'panes.title.margin.left'
        }, 
        panesTitleMarginRight: {
            type: Number,
            kComposite: 'panes.title.margin.right'
        }, 
        panesTitleMarginTop: {
            type: Number,
            kComposite: 'panes.title.margin.top'
        }, 
        panesTitlePosition: {
            type: String,
            kComposite: 'panes.title.position'
        }, 
        panesTitleText: {
            type: String,
            kComposite: 'panes.title.text'
        }, 
        panesTitleVisible: {
            type: Boolean,
            kComposite: 'panes.title.visible'
        }, 
        panesTitleVisual: {
            type: Function,
            kComposite: 'panes.title.visual'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Panes.js